/**
 * Payment-method tokens that appear verbatim as bt.rationale but carry no
 * entity identity information. Used to skip noise when building fallback chips.
 * Checked case-insensitively.
 */
export const PAYMENT_METHOD_NOISE = new Set([
    'neft',
    'bank transfer',
    'others',
    'other',
    'chq',
    'cheque',
    'rtgs',
    'cms',
    'payu',
    'paytm',
    'amazon',
    'transfer',
    'remit',
    'atm',
    'imps',
    'clg',
    'ach',
    'cash',
    'tpt',
    'razorpay',
    'card',
    'shiprocket',
    'cod',
    'upi',
    'cashfree',
    'chg',
    'inft',
    'instamojo',
    'pickrr',
    'mobikwik',
    'billdesk',
    'phonepe',
    'ccavenue',
    'mmt',
    'stripe',
    'tpsl',
    'paypal',
    'gateaway',
    'gateway',
    'interbank',
]);
